export const fetchFcmDelete = async (payload) => {

	const baseUrl = process.env.NEXT_PUBLIC_ROOT_DOMAIN;
	const url = `${baseUrl}${process.env.NEXT_PUBLIC_FCM}${process.env.NEXT_PUBLIC_FCM_DELETE}`;

	const options = {
		method: "POST",
		headers: {
			Authorization: payload.authorization || "",
			"Content-type": "application/json",
		},
		body: JSON.stringify(payload.body),
	};

	const response = await fetch(url, options);

	if (!response.ok) {

		return Promise.reject(await response.json());

	}
	const result = await response.json();

	return result;

};
